<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <SectionLayout :settings="fields.settings" :container-page="fields.containerPage" />

        <div class="mb-5">
          <label class="label-input">Main Image</label>
          <div class="group-item">
            <UploadImage
              :image="{ imageSrc: fields.mainImage.image }"
              :height="`260`"
              :typeUpload="'image'"
              @callback="obj => (fields.mainImage.image = obj.imageSrc)"
              @callbackDelete="fields.mainImage.image = ''"
            />
            <div class="mt-3">
              <label>Link (URL)</label>
              <v-text-field v-model="fields.mainImage.link" hide-details class="mt-0" />
            </div>
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input mb-2">Second Images ({{ SECOND_IMAGE_COUNT }})</label>
          <div v-for="(item, index) in fields.secondImages" :key="`second-image-${index}`" class="group-item mb-3">
            <label class="mb-2 d-block">Image {{ index + 1 }}</label>
            <UploadImage
              :image="{ imageSrc: item.image }"
              :height="`160`"
              :typeUpload="'image'"
              @callback="obj => (item.image = obj.imageSrc)"
              @callbackDelete="item.image = ''"
            />
            <div class="mt-3">
              <label>Link (URL)</label>
              <v-text-field v-model="item.link" hide-details class="mt-0" />
            </div>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import SectionLayout from '../common/ui-modules/section-layout/editor.vue';

// group-img-second là danh sách CỐ ĐỊNH số lượng: không cho add/remove item từ editor.
const SECOND_IMAGE_COUNT = 2;

const buildSecondImageDefault = () => ({
  image: '',
  link: '',
});

const getDefaultFields = () => ({
  title: 'Calyrafit Grid Image Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: true,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  mainImage: {
    image: '',
    link: '#',
  },
  secondImages: Array.from({ length: SECOND_IMAGE_COUNT }, () => buildSecondImageDefault()),
});

// Chuẩn hoá về đúng SECOND_IMAGE_COUNT phần tử: cắt bớt nếu thừa, bù thêm default nếu thiếu.
// Đây là chốt chặn duy nhất kiểm soát số lượng item - không có handler add/remove nào khác.
const normalizeSecondImages = items => {
  const list = Array.isArray(items) ? items.slice(0, SECOND_IMAGE_COUNT) : [];
  while (list.length < SECOND_IMAGE_COUNT) {
    list.push(buildSecondImageDefault());
  }
  return list;
};

export default {
  name: 'CalyrafitGirdImageSectionEditor',
  components: { UploadImage, SectionLayout },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      SECOND_IMAGE_COUNT,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const extract = cloneDeep(this.sectionEditor.sectionExtract || {});

    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
      mainImage: { ...def.mainImage, ...(extract.mainImage || {}) },
      secondImages: normalizeSecondImages(extract.secondImages),
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const payload = {
        ...this.fields,
        secondImages: normalizeSecondImages(this.fields.secondImages),
      };
      const updateHtml = updateHtmlFromData.sectionCalyrafitGirdImage(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
